import type { DistributionUICustomization } from "@searchui-searchforms/shared/customization";
import { createSafeContext } from "@/shared/utils/createSafeContext";

const [UICustomizationProvider, useUICustomization] = createSafeContext<DistributionUICustomization>("UICustomization");

export { UICustomizationProvider, useUICustomization };
